// extracted by mini-css-extract-plugin
export default {"ThreadHeaderIconButton":"ThreadHeader-module__ThreadHeaderIconButton--RGjVM"};